export const ReviewSorting = {
  RATING_ASC: 'RATING_ASC',
  RATING_DESC: 'RATING_DESC',
  DATE_DESC: 'DATE_DESC',
  HELPFUL_DESC: 'HELPFUL_DESC',
} as const;

export type ReviewSorting = keyof typeof ReviewSorting;

export const VerificationStatus = {
  VERIFIED: 'VERIFIED',
  NOT_VERIFIED: 'NOT_VERIFIED',
} as const;

export type VerificationStatus = keyof typeof VerificationStatus;

export type ReviewSource = 'SITE' | 'ADMIN' | 'IMPORT';

export interface Review {
  id: number;
  product_id: number;
  product_handle: string;
  product_title: string;
  product_image_src: string | null;
  product_overall_rating: number;
  product_reviews_count: number;
  product_summary: string;
  author: string;
  verified_purchase: VerificationStatus;
  created_at: string;
  location: string | null;
  title: string;
  images: { image_key: string }[];
  rating: number;
  body: string;
  pros: string | null;
  cons: string | null;
  reply: string | null;
  replied_at: string | null;
  vote_up: number;
  vote_down: number;
  source: ReviewSource;
}
